<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="创建时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleMerchantInfoFilter">
              <el-option
                v-for="(item, index) in subMerchantNamesList"
                :key="index"
                :label="item.code"
                :value="item.code">
                <span class="value">{{ item.code }}</span>
                <span class="name">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打款订单号">
            <el-input
              class="search-input"
              v-model="billId"
              placeholder="打款订单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="打款类型">
            <el-select style="width: 120px;" v-model="settleType" @change="profitType = ''">
              <el-option label="D0" value="0"></el-option>
              <el-option label="D1" value="1"></el-option>
              <el-option label="D1（合并）" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打款状态">
            <el-select style="width: 120px;" v-model="state" clearable>
              <el-option label="打款失败" value="-1"></el-option>
              <el-option label="打款中" value="0"></el-option>
              <el-option label="打款成功" value="1"></el-option>
              <el-option label="打款退票 " value="2"></el-option>
              <el-option label="冻结出款" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提现类型" v-show="settleType === '2'">
            <el-select style="width: 120px;" v-model="profitType" clearable>
              <el-option label="分时结算" :value="4"></el-option>
              <el-option label="分账结算" :value="17"></el-option>
              <el-option label="补贴结算" :value="11"></el-option>
              <el-option label="合并结算" :value="15"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              icon="el-icon-download"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <div class="tip-view">
          说明：<br>
          1、目前只展示近期1个月的所有打款订单，和累积所有打款失败订单；<br>
          2、打款类型分为D0/D1/D1合并，打款单改造(2020/6/9)后原D1合并的打款数据（包括分时结算/分账结算等）统一在D1中查看。
        </div>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="payOrderList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fcreateTime"
          label="创建时间"
          width="95px"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fBillId"
          label="打款单号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAmount"
          label="实际打款金额"
          align="center">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.fAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fState"
          label="打款状态"
          align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.fState | formatState }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="settleType === '2'"
          prop="profitTypeStr"
          label="提现类型"
          align="center"></el-table-column>
        <el-table-column
          prop="fRemark"
          label="备注"
          align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.fRemark || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fupdateTime"
          label="更新时间"
          width="95px"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fSettleType"
          label="结算类型"
          align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.fSettleType | formatSettleType }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fBankHolder"
          label="开户名"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fBankName"
          label="银行名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fBankAccount"
          label="开户账号"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>
              <auth-button opt="details" type="text" v-if="scope.row.fSettleType === 1" @click.native="showDetailInfo(scope.row)" label="查看详情"></auth-button>
              <span v-else>--</span>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
    <el-dialog
      title="打款详情"
      :visible.sync="detailInfoVisible"
      @close="clearInfo"
      width="30%">
      <div class="mgb15">打款单号 <span class="mgl30">{{ detailInfo.billId }}</span></div>
      <div class="mgb15">实际打款金额 <span class="mgl30">{{ detailInfo.amountStr }}元</span></div>
      <div class="mgb15">款项明细</div>
      <el-table
        border
        :data="detailInfo.payDetailList"
        :span-method="objectSpanMethod"
        style="width: 100%">
        <el-table-column prop="type" align="center" label=""/>
        <el-table-column
          prop="payDetail"
          align="center"
          label="款项类型">
        </el-table-column>
        <el-table-column
          prop="number"
          align="center"
          label="金额（元）">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { getAllSubMerchantNames, listPayOrder, exportPayOrder, lookUpDetailInfo } from '@/api/settle.js'
export default {
  name: 'PaymentInquiry',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    return {
      loading: false,
      detailInfoVisible: false,
      transDetailList: [],
      transferList: [],
      detailInfo: {
        billId: '',
        amountStr: '',
        payDetailList: []
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        merchantId: '',
        merchantName: '',
        billId: '',
        settleType: '',
        state: '',
        profitType: ''
      },
      creatTime: [],
      merchantId: '',
      merchantName: '',
      billId: '',
      settleType: '1',
      state: '',
      tableLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      subMerchantNamesList_back: [],
      payOrderList: [],
      profitType: ''// 提现类型筛选项
    }
  },
  mounted () {
    this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      // this.loading = true
      await this.getAllSubMerchantNames()
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.setSearchInfoParams(noReset)
      this.listPayOrder()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      this.setSearchInfoParams(true)
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          // message: '请筛选1个月内的数据进行导出',
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      this.exportPayOrder()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.merchantName = this.merchantName.replace(/ /g, '') || ''
      this.searchInfo.billId = this.billId.replace(/ /g, '') || ''
      this.searchInfo.settleType = this.settleType
      this.searchInfo.state = this.state || ''
      this.searchInfo.profitType = this.profitType || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      this.creatTime = value
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 商户选择筛选商户方法
     */
    handleMerchantInfoFilter (queryString) {
      if (queryString) {
        this.subMerchantNamesList = this.subMerchantNamesList_back.filter(item => {
          return item.code.toLowerCase().includes(queryString.toLowerCase()) || item.name.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subMerchantNamesList = this.subMerchantNamesList_back
      }
    },
    /**
     * 获取商户编号下拉列表
     */
    getAllSubMerchantNames () {
      return new Promise((resolve, reject) => {
        getAllSubMerchantNames('').then(response => {
          console.log('getAllSubMerchantNames response:', response)
          if (response.error_code === '0') {
            this.subMerchantNamesList = response.data
            this.subMerchantNamesList_back = [...this.subMerchantNamesList]
            this.merchantId = this.subMerchantNamesList[0].code
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch(err => {
          this.loading = false
          reject(err)
        })
      })
    },
    /**
     * 打款查询
     */
    listPayOrder () {
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      //   this.$message({
      //     message: '请筛选1个月内的数据进行查询',
      //     type: 'error'
      //   })
      //   return
      // }
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      listPayOrder(params).then(response => {
        console.log('listPayOrder response:', response)
        this.loading = false
        if (response.error_code === '0') {
          this.payOrderList = response.data.list
          this.paginations.count = response.data.totalCount
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 打款单查询导出
     */
    exportPayOrder () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 3,
        moduleName: '打款',
        menuName: '打款查询'
      }))
      exportPayOrder(params).then(response => {
        this.exportButtonLoading = false
        if (response.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 查看详情
     */
    showDetailInfo (row) {
      const params = qs.stringify({
        merchantId: row.fMerchantId,
        billId: row.fBillId
      })
      lookUpDetailInfo(params).then(res => {
        if (parseInt(res.result_cde) === 0) {
          this.detailInfo.billId = res.billId
          this.detailInfo.amountStr = res.amountStr
          if (res.transDetailList && res.transDetailList.length > 0) {
            this.transDetailList = res.transDetailList.map(item => {
              return {
                type: '交易明细',
                payDetail: item.sourceStr,
                number: item.amountStr
              }
            })
          }
          if (res.transferList && res.transferList.length > 0) {
            this.transferList = res.transferList.map(item => {
              return {
                type: '合并明细',
                payDetail: item.sourceStr,
                number: item.amountStr
              }
            })
          }
          const zfDetail = [{
            type: '止付明细',
            payDetail: '/',
            number: res.stopAmountStr || 0
          }]
          this.detailInfo.payDetailList = [...this.transDetailList, ...this.transferList, ...zfDetail]
          this.detailInfoVisible = true
        } else {
          this.$message({
            message: res.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 清除信息
     */
    clearInfo () {
      this.transferList = []
      this.transDetailList = []
    },
    /**
     * 合并行
     */
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      const num1 = this.transDetailList.length
      const num2 = this.transferList.length
      if (num1 > 0 && num2 > 0) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return [num1, 1]
          } else if (rowIndex === num1) {
            return [num2, 1]
          } else if (rowIndex === num1 + num2) {
            return [1, 1]
          } else {
            return [0, 0]
          }
        }
      }
      if (num1 > 0 && num2 === 0) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return [num1, 1]
          } else if (rowIndex === num1) {
            return [1, 1]
          } else {
            return [0, 0]
          }
        }
      }
      if (num2 > 0 && num1 === 0) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return [num2, 1]
          } else if (rowIndex === num2) {
            return [1, 1]
          } else {
            return [0, 0]
          }
        }
      }
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {
    formatSettleType (value) {
      switch (value) {
        case 0:
          return 'D0'
        case 1:
          return 'D1'
        case 2:
          return 'D1（合并）'
        default:
          return '未知'
      }
    },
    formatState (value) {
      switch (value) {
        case -1:
          return '打款失败'
        case 0:
          return '打款中'
        case 1:
          return '打款成功'
        case 2:
          return '打款退票'
        case 3:
          return '冻结出款'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.tip-view {
  margin: 10px;
  font-size: 14px;
}
.mgb15 {
  margin-bottom: 15px
}
.mgl30 {
  margin-left:30px
}
</style>
<style>
.el-dialog__body {
  padding: 20px
}
</style>
